import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { withRouter, Link } from 'react-router-dom';
import classNames from 'classnames';
import { find } from 'lodash';
import { connect } from 'react-redux';
import { getPrettyUrl } from '../../helpers.js';

class Artist extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      photographer: false,
      introHidden: false,
    };
  }

  componentDidMount(){
  }

  componentDidUpdate(prevProps){
  }

  _setupPage(){
    // const { photographer } = this.state;
    //
    // document.body.style.background = photographer.acf.secondary_color;
  }

  render () {
    console.log(this.props.artist);
    const { artist } = this.props;

    if(!artist){
      return false;
    }

    return <div className={classNames('page page--artist-information transition')} style={{backgroundColor: artist.acf.secondary_color}}>
          <h1 className="artist__title" style={{color: artist.acf.primary_color}}>{artist.title.rendered}</h1>
          {artist.content.rendered &&
            <div className="artist__description" dangerouslySetInnerHTML={{ __html: artist.content.rendered }} />
          }
          <ul className="artist__social-media" style={{color: artist.acf.primary_color}}>
            {artist.acf.instagram_url &&
              <li className="artist__social-media__item"><a href={artist.acf.instagram_url} data-color={artist.acf.primary_color} target="_blank">Instagram</a></li>
            }
            {artist.acf.vimeo_url &&
              <li className="artist__social-media__item"><a href={artist.acf.vimeo_url} data-color={artist.acf.primary_color} target="_blank">Vimeo</a></li>
            }
            {artist.acf.website_url &&
              <li className="artist__social-media__item"><a href={artist.acf.website_url} data-color={artist.acf.primary_color} target="_blank">{getPrettyUrl(artist.acf.website_url)}</a></li>
            }
          </ul>
        <Link className="navigation navigation--back" to={`/${artist.type}s/${artist.slug}`}>Back to Artist Page</Link>
      </div>;
  }
}



const mapStateToProps = (state, ownProps) => {
  const artists = state.photographers.concat(state.directors);
  const artist = find(artists, {slug: ownProps.match.params.slug});

  return {
    artist
  }
}

export default withRouter(connect(mapStateToProps, null)(Artist));
